import React from 'react';
import PropTypes from 'prop-types';

import { Separator } from '../separator';
import { GlossaryEntry } from '../../../common/glossary-entry';
import { GlossaryText } from '../../../models/GlossaryText';
import styles from './CharacteristicsSection.css';

const IPropTypes = {
  characteristics: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    characteristics: PropTypes.arrayOf(PropTypes.shape({
      key: PropTypes.string.isRequired,
      value: PropTypes.arrayOf(PropTypes.instanceOf(GlossaryText)).isRequired,
    })).isRequired,
  })).isRequired,
  mobileVersion: PropTypes.bool,
};

const defaultProps = {
  mobileVersion: false,
};

class CharacteristicsSection extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      expanded: false,
    };
    this._expandList = this._expandList.bind(this);
  }

  _expandList() {
    this.setState({
      expanded: true,
    });
  }

  render() {
    const expandedClass = (this.state.expanded || !this.props.mobileVersion) ? styles.expanded : '';
    return (
      <section className={styles.container}>
        <h2 className={styles.title}>Características</h2>
        <div
          className={[styles.charContainer, expandedClass].join(' ')}
        >
          {
            this.props.characteristics.map(category => (
              <div key={category.id}>
                <h4 className={styles.category}>{category.name}</h4>
                {category.characteristics.map(char => (
                  <div
                    className={styles.characteristicContainer}
                    key={char.key}
                  >
                    <div className={styles.charKey} style={{ color: !char.visible && char.key !== 'Marca' && char.key !== 'Modelo' && 'red' }}>
                      <div className={styles.leftCharKey}>
                        {char.key}
                      </div>
                      {
                        !!char.featured && (
                          <div>
                            <span className={styles.label}>
                              {char.featured}
                            </span>
                          </div>
                          )
                      }
                    </div>
                    <div className={styles.charValue} style={{ color: !char.visible && char.key !== 'Marca' && char.key !== 'Modelo' && 'red' }}>
                      {char.value.map(value => (
                        <p
                          className={styles.charValueParagraph}
                          key={value.entries[0].text}
                        >
                          <GlossaryEntry className={styles.glossaryText} entry={value} />
                        </p>
                      ))}
                    </div>
                  </div>
                ))}
                {
                  !this.props.mobileVersion &&
                  <Separator />
                }
              </div>
            ))
          }
          {
            !this.state.expanded && this.props.mobileVersion &&
            <div className={styles.overlay} />
          }
        </div>
        {
          !this.state.expanded && this.props.mobileVersion &&
          <button
            className={styles.viewAllButton}
            onClick={this._expandList}
          >
            Ver todas ›
          </button>
        }
      </section>
    );
  }
}

CharacteristicsSection.propTypes = IPropTypes;
CharacteristicsSection.defaultProps = defaultProps;

export { CharacteristicsSection };



// WEBPACK FOOTER //
// ./src/pages/product-detail/characteristics-section/CharacteristicsSection.jsx